import type { CommandCenterClaimCard } from "@/api/types";
import { ClaimLink, ClientLink, PolicyLink } from "@/components/EntityLinks";
import { formatCurrency, statusClass } from "@/utils/format";

export function ClaimQueueTable({
  title,
  items,
}: {
  title: string;
  items: CommandCenterClaimCard[];
}) {
  return (
    <div className="card" style={{ padding: "1rem" }}>
      <h3>{title}</h3>
      {items.length === 0 ? (
        <div className="empty-state">Nothing in this queue.</div>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Claim</th>
              <th>Policy</th>
              <th>Client</th>
              <th>Status</th>
              <th>Amount</th>
              <th>Fraud</th>
              <th>SLA</th>
            </tr>
          </thead>
          <tbody>
            {items.map((claim) => (
              <tr key={claim.claim_id}>
                <td>
                  <ClaimLink id={claim.claim_id}>
                    {claim.external_ref ?? claim.claim_id.slice(0, 8)}
                  </ClaimLink>
                </td>
                <td>
                  {claim.policy_id ? (
                    <PolicyLink id={claim.policy_id}>{claim.policy_number}</PolicyLink>
                  ) : (
                    claim.policy_number
                  )}
                </td>
                <td>
                  {claim.customer_id ? (
                    <ClientLink id={claim.customer_id}>View</ClientLink>
                  ) : (
                    "—"
                  )}
                </td>
                <td>
                  <span className={statusClass(claim.status)}>{claim.status}</span>
                </td>
                <td>{formatCurrency(claim.amount_cents)}</td>
                <td>{claim.fraud_score?.toFixed(1) ?? "—"}</td>
                <td>{claim.sla_status ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
